/**
 * ExecuteTestsIcon — crossed swords (combat).
 * Phase: execute-tests.
 */

import type { ReactNode } from 'react';

interface IconProps {
  readonly size?: number;
  readonly color?: string;
}

export function ExecuteTestsIcon({ size = 18, color = '#F4EFE2' }: IconProps): ReactNode {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M4 4l8 8" />
      <path d="M14 14l6 6" />
      <path d="M20 4l-8 8" />
      <path d="M10 14l-6 6" />
      <path d="M11 11l2 2" />
    </svg>
  );
}
